import { render, staticRenderFns } from "./LoanCommittee.vue?vue&type=template&id=397bd076"
import script from "./LoanCommittee.vue?vue&type=script&lang=js"
export * from "./LoanCommittee.vue?vue&type=script&lang=js"
import style0 from "./LoanCommittee.vue?vue&type=style&index=0&id=397bd076&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports